import { useMemo } from 'react';

import { getInfo, NameAndCreateDateFormatter, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn, deleteAction, editAction, toggleFormatter, defaultColumnId } from '@Components/Grid/utils/column';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />),
    defaultColumn('key', 'Key', info => <TruncateWithTooltipFormatter info={info} />),
    column.accessor('type', {
      header: 'Type',
      cell: info => <TypeFormatter info={info} />,
    }),
    defaultColumn('private', 'Private', toggleFormatter, { initialSize: 'w-18', enableColumnResize: false }),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}

function TypeFormatter({ info }) {
  const { row } = getInfo(info)
  const { type } = row
  return typeOptions[type]
}

const typeOptions = {
  input: 'Text',
  integer: 'Integer',
  select: 'Option',
  boolean: 'Boolean',
  date: 'Date',
}
